<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'invoices_download' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="row pagination-box">
          <div class="col-xs-6">
            <a class="btn btn-info" target="_blank" href="/static/img/qb-csv-download-windows.pdf"><i class="fa fa-cloud-download mr-5"></i>CSV-Anleitung Windows</a>
            <a class="btn btn-info" target="_blank" href="/static/img/qb-csv-download.pdf"><i class="fa fa-cloud-download mr-5"></i>CSV-Anleitung MAC</a>
          </div>
          <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
        </div>
      </div>
      <div class="box-body">
        <sapInvoicesTable :language="$store.getters.language" :items="items"></sapInvoicesTable>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
    <div class="overlay" v-show="loading">
      <img class="loading-gif" src="/static/img/blabla.svg"/>
    </div>
  </section>
</template>
<script>
import VueMonthlyPicker from 'vue-monthly-picker'

export default {
  name: 'Bills',
  data () {
    return {
      loading: false,
      startRange: moment().subtract(1, 'month'),
      endRange: moment(),
      items: [],
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      }
    }
  },
  components: {
    VueMonthlyPicker: VueMonthlyPicker
  },
  methods: {
    paginate (type, value) {
      let url = '?preflight=kek'
      if (type === 'page') {
        url += '&page='
        if (value === 'previous') {
          url += (this.pagination.current_page - 1)
        }
        if (value === 'next') {
          url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
        } else if (value !== 'next' && value !== 'previous') {
          url += value
        }
        API.get(`/download/invoices/sap${url}`)
          .then(response => {
            this.pagination = response.data
            this.items = this.sort(this.pagination.data)
          })
      }
    },
    sort (arr) {
      return arr.sort((a,b) => {
        return parseInt(b.invoice_number) - parseInt(a.invoice_number)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$store.dispatch('checkPermissions', 'co_products')) {
        API.get('download/invoices/sap')
          .then(response => {
            this.pagination = response.data
            this.items = this.sort(this.pagination.data)
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
  .picker:not(.month-year-label) {
    background: #212228;
  }
  .picker > .flexbox:not(.monthItem) {
    background-color: rgba(0,195,150,.075);
    border-color: #00C396;
    color: #00C396;
    font-weight: 600;
  }
  .picker > .flexbox.monthItem {
    background-color: #212228 ;
    color: white;
    font-weight: 600;
    border-top: 1px solid rgba(255,255,255, .15) !important;
  }
  .picker .monthItem .item:hover {
    background-color: #00C396 !important;
  }
  .date-popover{
    background: none !important;
    border: 1px solid rgba(255,255,255, .15) !important
  }
</style>
<style scoped>
  .loading-gif {
    display: block;
    width: 5%;
    top: 42%;
    left: 50%;
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Downloads/SapBills.vue